export const GOOGLE_MAPS_API_KEY = 'AIzaSyABKLhxh-cOIHneCqllpc1VNcP-SOU5ncg';
export const GOOGLE_MAPS_LIBRARIES: 'places'[] = ['places'];

const geocodeCache = new Map<string, google.maps.LatLngLiteral | null>();

export const geocodeCity = (city: string) =>
  new Promise<google.maps.LatLngLiteral | null>((resolve) => {
    if (geocodeCache.has(city)) {
      resolve(geocodeCache.get(city) ?? null);
      return;
    }
    new google.maps.Geocoder().geocode(
      { address: `${city}, Brasil`, region: 'br' },
      (results, status) => {
        const location = status === 'OK' ? results?.[0]?.geometry?.location : undefined;
        const value = location ? { lat: location.lat(), lng: location.lng() } : null;
        geocodeCache.set(city, value);
        resolve(value);
      },
    );
  });
